import { Heading, Stack } from "@chakra-ui/react";
import { DirtyAwareNavLink } from "../elements/DirtyAwareNavLink";

export function Sidebar() {
  return (
    <Stack as="nav" backgroundColor="gray.100" flexShrink={0} h="100%" padding="1rem" w="2xs">
      <DirtyAwareNavLink end to="/">Home</DirtyAwareNavLink>
      <DirtyAwareNavLink to="/import">Importeren</DirtyAwareNavLink>
      <DirtyAwareNavLink to="/residence-types">Woningtypen</DirtyAwareNavLink>
      <DirtyAwareNavLink to="/situations">Situaties</DirtyAwareNavLink>
      <DirtyAwareNavLink to="/scenarios">Scenario&apos;s</DirtyAwareNavLink>
      <DirtyAwareNavLink to="/customers">Opdrachtgevers</DirtyAwareNavLink>
      <Heading as="h2" fontSize="lg" marginTop="2rem">Stamgegevens</Heading>
      <DirtyAwareNavLink to="/residence-categories">Woningcategorieën</DirtyAwareNavLink>
      <DirtyAwareNavLink to="/roof-types">Daktypes</DirtyAwareNavLink>
    </Stack>
  )
}